import { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import MainPageLayout from "../../../layout/MainPageLayout";
import useGetHistory from "../../../CustomHooks/useAxios/useGetHistory";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import { setError } from "../../../redux/dataSlice";
import useGetMultiple from "../../../CustomHooks/useAxios/useGetMultiple";
import LoadingDisplay from "../../../components/UI/LoadingDisplay";
import { CYLINDER_SETUP, FACTORY_SETUP } from "../../../api/allApi_List";
import JobCardReviewHistorySelector from "../components/jobCardInform/JobCardReviewHistorySelector";
import NoHistoryView from "../../cylinder/components/history/NoHistoryView";
import JobCardInformCard from "../components/jobCardInform/JobCardInformCard";
import JobCardCheckpointFilter from "../components/jobCardInform/JobCardCheckpointFilter";

const CylinderCheckpointReviewHistoryPage = () => {
  const [selectedCheckpointId, setSelectedCheckpointId] = useState("");
  const { data, isLoaded, error } = useGetMultiple([
    CYLINDER_SETUP,
    FACTORY_SETUP,
  ]);
  const { getHistory, historyLoaded, isSucceed } = useGetHistory();
  const dispatch = useDispatch();
  const logsData = useSelector((state) => state.data.data);
  const historyError = useSelector((state) => state.data.error);
  const historyErrMsg = useSelector((state) => state.data.errMessage);

  // Filter Data based on the checkpoints
  const filteredData = useMemo(() => {
    const informedData = logsData ?? [];
    if (!selectedCheckpointId) return informedData;

    return informedData.filter(
      (item) => item.checkpoint.checkpointId === Number(selectedCheckpointId),
    );
  }, [logsData, selectedCheckpointId]);

  return (
    <>
      <MainPageLayout
        headerConfig={{ title: "Cylinder Job Card Update History" }}
        bgColor="bg-dBlue-100"
      >
        {isLoaded && !error ? (
          <div className="flex gap-2 my-3 h-[calc(100vh-5em)] flex-col">
            {/* DATE RANGE AND CYLINDER SELECTOR */}
            <JobCardReviewHistorySelector
              historyLoaded={historyLoaded}
              getHistory={getHistory}
              setupData={data[0]}
            />
            <div className="bg-white h-full rounded-lg border-1 border-dBlue-100 p-2">
              {isSucceed && logsData.length !== 0 ? (
                <>
                  <div className="mb-3 md:flex justify-between items-center">
                    <h2 className="max-md:text-sm font-semibold max-md:pb-2">
                      Cylinder Job Card Update History
                    </h2>
                    <JobCardCheckpointFilter
                      setupData={data[1]}
                      setSelectedCheckpointId={setSelectedCheckpointId}
                    />
                  </div>
                  <div className="h-[calc(100vh-18em)] max-md:h-[calc(100vh-32em)] overflow-y-auto space-y-2">
                    {filteredData.length > 0 ? (
                      filteredData.map((item) => {
                        return <JobCardInformCard item={item} key={item.id} />;
                      })
                    ) : (
                      <NoHistoryView msg="No Searched History Found" />
                    )}
                  </div>
                </>
              ) : (
                <NoHistoryView
                  msg={`${isSucceed ? " No Updates History Found!" : "No Updates History Searched...!"}`}
                />
              )}
            </div>
          </div>
        ) : error ? (
          <DialogBox
            title="Error"
            message={handleErrMessage(error)}
            isErrorHandleButtons={true}
          />
        ) : (
          <LoadingDisplay height="h-[90vh] mt-2" />
        )}
      </MainPageLayout>
      {historyError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(historyErrMsg)}
          closeAction={() => dispatch(setError("false"))}
        />
      )}
    </>
  );
};

export default CylinderCheckpointReviewHistoryPage;
